import { useCallback } from "react";
import { Platform } from "react-native";
import { OS } from "../shared/config";

declare global {
  interface Window {
    _mfq: {
      push(array: [string, string]): unknown;
    };
  }
}

const useMouseFlow = () => {
  const fireMouseFlowEvent = useCallback((variableName: string, variableId: string) => {
    if (Platform.OS === OS.WEB && globalThis?.window?._mfq) {
      const { _mfq: mouseFlow } = window;

      return mouseFlow.push([`${variableName}`, `${variableId}`]);
    }

    return null;
  }, []);

  return { fireMouseFlowEvent };
};

export { useMouseFlow };
